import AboutTraits from './AboutTraits';
export default AboutTraits;
